import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '@environment/environment';
import { LoggerService } from '@app/core/infrastructure';
import { CareLink, InviteCaregiverRequest, RevokeResponse } from './care-links-api.models';

@Injectable({
  providedIn: 'root'
})
export class CareLinksApiService {
  private readonly logger = inject(LoggerService).scope('CareLinksApiService');
  private readonly apiUrl = `${environment.API_BASE_URL}/protected/care/links`;

  constructor(private http: HttpClient) {
    this.logger.debug('Initialized');
  }

  getMyCaregivers(): Observable<CareLink[]> {
    return this.http.get<CareLink[]>(`${this.apiUrl}/my-caregivers`).pipe(
      catchError(error => {
        this.logger.error('Error fetching caregivers:', error);
        return throwError(() => new Error('Failed to fetch caregivers'));
      })
    );
  }

  inviteCaregiver(request: InviteCaregiverRequest): Observable<CareLink> {
    return this.http.post<CareLink>(`${this.apiUrl}/invite`, request).pipe(
      catchError(error => {
        this.logger.error('Error inviting caregiver:', error);
        return throwError(() => error);
      })
    );
  }

  revokeLink(linkId: string): Observable<RevokeResponse> {
    return this.http.delete<RevokeResponse>(`${this.apiUrl}/${linkId}/revoke`).pipe(
      catchError(error => {
        this.logger.error('Error revoking care link:', error);
        return throwError(() => new Error('Failed to revoke care link'));
      })
    );
  }

  resendInvitation(linkId: string): Observable<CareLink> {
    return this.http.post<CareLink>(`${this.apiUrl}/${linkId}/resend`, {}).pipe(
      catchError(error => {
        this.logger.error('Error resending invitation:', error);
        return throwError(() => new Error('Failed to resend invitation'));
      })
    );
  }
}
